import { clientDeleteCookie, clientSetCookie, CookieName, isWindowDefined } from '@chegg/utils';
import useIsCampaignIdEnabled from './useIsCampaignIdEnabled';
import useCampaignCookie, { readCampaignCookie } from './useCampaignCookie';
import { useEffect } from 'react';
var COUPON_CODE_PARAM_KEY = 'cp';
var CAMPAIGN_NAME_PARAM_KEY = 'campaignName';
var setCouponCampaignCookie = function setCouponCampaignCookie(couponCode, campaignName) {
  var couponCampaignCookie = {
    couponCode: couponCode,
    campaignName: campaignName
  };
  clientSetCookie(CookieName.COUPON_CAMPAIGN, JSON.stringify(couponCampaignCookie));
};
var clearCampaignQueryParam = function clearCampaignQueryParam() {
  if (!isWindowDefined) {
    return;
  }
  var url = new URL(window.location.href);
  url.searchParams["delete"](CAMPAIGN_NAME_PARAM_KEY);
  window.history.replaceState({}, window.document.title, url);
};

/**
 * Hook to handle client-side auto-apply coupon behavior
 */
var useAutoApplyCoupon = function useAutoApplyCoupon() {
  var searchParams = isWindowDefined ? new URL(window.location.href).searchParams : new URLSearchParams();
  var couponCodeFromQuery = searchParams.get(COUPON_CODE_PARAM_KEY);
  var campaignNameFromQuery = searchParams.get(CAMPAIGN_NAME_PARAM_KEY);
  var isCampaignEnabled = useIsCampaignIdEnabled(campaignNameFromQuery || '');
  var cacheCampaignCookie = useCampaignCookie();
  var campaignCookie = readCampaignCookie();
  useEffect(function () {
    var shouldCacheCampaignCookie = (campaignCookie === null || campaignCookie === void 0 ? void 0 : campaignCookie.couponCode) && campaignCookie.campaignName;
    if (shouldCacheCampaignCookie) {
      cacheCampaignCookie(campaignCookie);
      clientDeleteCookie(CookieName.COUPON_CAMPAIGN);
    }
  }, [campaignCookie]);
  useEffect(function () {
    var shouldSetCampaignAsCookie = isCampaignEnabled && couponCodeFromQuery && campaignNameFromQuery;
    if (shouldSetCampaignAsCookie) {
      setCouponCampaignCookie(couponCodeFromQuery, campaignNameFromQuery);
      clearCampaignQueryParam();
    }
  }, [isCampaignEnabled, couponCodeFromQuery, campaignNameFromQuery]);
};
export default useAutoApplyCoupon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useAutoApplyCoupon.js
// module id = 4120
// module chunks = 11